import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogContent, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useCallback, useContext, useState } from 'react';
import { checkIfWorkingDay, IsInPreviousEntitlementYear } from '../../functions';
import { ModalActionKind, ReducerContext } from '../../hooks';
import { theme } from '../../themes';
import { CalendarBookingMessages } from '../../types/CalendarBookingMessages';
import { AlertInfo } from '../AlertInfo';
import { CloseDialogButton } from '../CloseDialogButton';
import { NewBookingContext } from '../NewBookingContext';
import { AddAbsenceDrawer } from './AddAbsenceDrawer';
import { AddAbsenceTitleDialog } from './AddAbsenceTitleDialog';
export const AddAbsenceDialog = () => {
    const [openStepper, setOpenStepper] = useState(false);
    const { modalState, modalDispatch, userSettingsState } = useContext(ReducerContext);
    const selectedDate = modalState.addBookingModalDate?.format('D MMMM YYYY');
    const [newBookingState, setNewBookingState] = useState({
        dateRange: { startDate: null, endDate: null },
        startInAfternoon: false,
        endInMorning: false,
        isManagerApprovalRequired: false,
        deductFromEntitlement: false,
    });
    const onCancel = () => {
        setNewBookingState({
            dateRange: { startDate: null, endDate: null },
            startInAfternoon: false,
            endInMorning: false,
            isManagerApprovalRequired: false,
            deductFromEntitlement: false,
        });
        modalDispatch({ type: ModalActionKind.ClosePromptAddAbsence });
    };
    const onConfirm = () => {
        setOpenStepper(true);
        setNewBookingState((state) => ({
            ...state,
            dateRange: { ...state.dateRange, startDate: moment(selectedDate) },
        }));
        modalDispatch({ type: ModalActionKind.ClosePromptAddAbsence });
    };
    const dialogMessageGrid = (selectedDate, showPreviousEntitlementYear) => {
        return (_jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { variant: 'body2', children: `Nothing booked here yet. Do you want to start your new holiday request from ${selectedDate?.format('MMMM D, YYYY')}` }) }), showPreviousEntitlementYear && (_jsx(Grid, { item: true, xs: 12, children: _jsxs(AlertInfo, { children: [_jsx(Typography, { variant: 'subtitle1', fontWeight: 'bold', children: CalendarBookingMessages.previousEntitlementYear.title }), _jsx(Typography, { variant: 'subtitle2', children: CalendarBookingMessages.previousEntitlementYear.message })] }) })), _jsx(Grid, { item: true, xs: 12, children: _jsx(AlertInfo, { children: _jsx(Typography, { variant: 'subtitle1', fontWeight: 'bold', children: CalendarBookingMessages.historyAbsence.title }) }) })] }));
    };
    const dialogMessage = useCallback(() => {
        if (!modalState.addBookingModalDate) {
            return;
        }
        if (!checkIfWorkingDay(modalState.addBookingModalDate.toDate(), userSettingsState.workingDays)) {
            return (_jsx(Typography, { variant: 'body2', children: "This is a non-working day. Please close and select a working day." }));
        }
        const isInPast = modalState.addBookingModalDate < moment();
        if (isInPast &&
            IsInPreviousEntitlementYear(modalState.addBookingModalDate.toDate(), userSettingsState.end)) {
            return dialogMessageGrid(modalState.addBookingModalDate, true);
        }
        if (isInPast) {
            return dialogMessageGrid(modalState.addBookingModalDate, false);
        }
        return (_jsxs(Typography, { variant: 'body2', children: ["Do you want to start your new holiday request from ", selectedDate, "?"] }));
    }, [
        modalState.addBookingModalDate,
        selectedDate,
        userSettingsState.end,
        userSettingsState.workingDays,
    ]);
    if (modalState.addBookingModalDate === undefined ||
        modalState.addBookingModalDate === null) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Dialog, { open: modalState.isPromptAddAbsenceOpen, onClose: onCancel, hideBackdrop: true, children: [_jsxs(AddAbsenceTitleDialog, { children: [_jsxs(Box, { children: [_jsx(Typography, { variant: "body1", fontWeight: 'bold', children: selectedDate }), _jsx(Typography, { variant: 'subtitle2', children: "working day" })] }), _jsx(Box, { children: _jsx(CloseDialogButton, { onClose: onCancel }) })] }), _jsx(DialogContent, { style: { padding: '15px 15px' }, children: dialogMessage() }), checkIfWorkingDay(modalState.addBookingModalDate.toDate(), userSettingsState.workingDays) && (_jsxs(DialogContent, { sx: {
                            borderTop: '0.5px solid',
                            borderColor: theme.palette.primary.main,
                            gap: 2,
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            padding: '10px 10px',
                        }, children: [_jsx(Button, { onClick: onCancel, children: "CANCEL" }), _jsx(Button, { onClick: onConfirm, variant: 'contained', children: "YES" })] }))] }), _jsx(NewBookingContext.Provider, { value: {
                    ...newBookingState,
                    updateState: setNewBookingState,
                }, children: _jsx(AddAbsenceDrawer, { setOpenDrawer: setOpenStepper, openDrawer: openStepper, date: modalState.addBookingModalDate }) })] }));
};
